// AI-CONTEXT: See docs/features/impact-in-beeld-fase3.md
import { impactPageUrl } from './impactPageUrl'

/**
 * Kopieerbare iframe-snippet voor de website-/webshop-widget: de publieke
 * impactpagina in compacte embed-modus. Bewust zónder scan-markering —
 * embed-weergaves zijn geen QR-scans.
 *
 * @param {object} input
 * @param {string} input.origin - Absolute origin (bv. https://app.deccos.nl)
 * @param {string} input.client - Tenant-CompagnyID
 * @param {string} [input.slug] - Product-slug voor een product-widget
 * @returns {string} de HTML-snippet om in een website te plakken
 */
const buildEmbedSnippet = ({ origin, client, slug }) => {
    const url = impactPageUrl({ origin, client, slug, embed: true })

    return `<iframe src="${url}" width="100%" height="480" frameborder="0" title="Onze maatschappelijke impact"></iframe>`
}

export { buildEmbedSnippet }
